"use strict";import{tag as o}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const CodeIcon=({width:l=24,height:t=24,hidden:e=!1,title:r="Code"}={})=>o`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${l}"
    height="${t}"
    viewBox="0 0 20 20"
    aria-hidden=${e?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
  >
    <path
      d="M5.5,14.5c-.19238,0-.38379-.07324-.53027-.21973l-3.75-3.75c-.29297-.29297-.29297-.76758,0-1.06055l3.75-3.75c.29297-.29297.76758-.29297,1.06055,0s.29297.76758,0,1.06055l-3.21973,3.21973,3.21973,3.21973c.29297.29297.29297.76758,0,1.06055-.14648.14648-.33789.21973-.53027.21973Z"
      fill="currentColor"
    />
    <path
      d="M14.5,14.5c-.19238,0-.38379-.07324-.53027-.21973-.29297-.29297-.29297-.76758,0-1.06055l3.21973-3.21973-3.21973-3.21973c-.29297-.29297-.29297-.76758,0-1.06055s.76758-.29297,1.06055,0l3.75,3.75c.29297.29297.29297.76758,0,1.06055l-3.75,3.75c-.14648.14648-.33789.21973-.53027.21973Z"
      fill="currentColor"
    />
    <path
      d="M8.22852,18c-.05859,0-.11816-.00684-.17676-.02051-.40332-.09766-.65039-.50293-.55371-.90527l3.5-14.5c.09766-.40332.50977-.64551.90527-.55371.40332.09766.65039.50293.55371.90527l-3.5,14.5c-.08301.34375-.39062.57422-.72852.57422Z"
      fill="currentColor"
    />
  </svg>`;
//# sourceMappingURL=Code.js.map
